export default "__VITE_ASSET__f017f514__"